<template>
  <div class="d-flex flex-column flex-root">
    <div class="d-flex flex-column flex-center min-vh-75 py-20">

      <!-- Code 403 -->
      <span class="fw-bolder fs-4x text-danger mb-2">403</span>

      <!-- Icône cadenas -->
      <div class="mb-8">
        <i class="fas fa-lock text-gray-300" style="font-size: 100px;"></i>
      </div>

      <!-- Titre -->
      <h1 class="fw-bolder fs-2x text-gray-800 mb-4">
        {{ $t('permission_denied') }}
      </h1>

      <!-- Description -->
      <p class="text-gray-500 fs-5 text-center mb-10" style="max-width: 420px;">
        {{ $t('permission_denied_text') }}
      </p>

      <!-- Bloc info -->
      <div class="d-flex align-items-center bg-light-warning rounded p-4 mb-10" style="max-width: 420px;">
        <i class="fas fa-info-circle text-warning fs-3 me-3 flex-shrink-0"></i>
        <span class="text-gray-700 fs-7">{{ $t('permission_denied_hint') }}</span>
      </div>

      <!-- Boutons -->
      <div class="d-flex gap-3">
        <button @click="$router.back()" class="btn btn-light">
          <i class="fas fa-arrow-left me-2"></i>{{ $t('back') }}
        </button>
        <router-link to="/" class="btn btn-primary">
          <i class="fas fa-home me-2"></i>{{ $t('permission_denied_home') }}
        </router-link>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'PermissionDenied',
}
</script>
